import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  Button,
  ModalHeader,
  Label,
  ModalFooter,
  Input,
  Alert,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";
import { FaArrowRight } from "react-icons/fa6";
import Select from "react-select";
import { BiEditAlt, BiX } from "react-icons/bi";
import {
  isUrlValid,
  uploadPreview,
  wikimediaAuth,
  triviaCategoryAPI,
  triviaListCategories,
} from "../../../utils/constants";
import { withRouter } from "react-router-dom";
import { toastContainer } from "../../../utils/toast";
// FaUber
import { FaUber } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { REWARD_ADMIN_EMAIL_TYPES } from "../data";

export default function RewardEditModal({
  editData,
  setEditData,
  open,
  onClose,
}) {
  const [rewardName, setRewardName] = useState(editData.rewardName);
  const [rewardDate, setRewardDate] = useState(editData.rewardDate);
  const [adminEmailTriggerType, setAdminEmailTriggerType] = useState(editData.adminEmailTriggerType);

  const handleDateChange = (value) => {
    setRewardDate(moment(value).local());
  };

  const handleUpdate=()=>{

    axios.put(url.updateReward(editData._id),{
        rewardName,rewardDate,adminEmailTriggerType
    }).then(({data})=>{
        toastContainer("Updated successfully","success")
        setEditData(data.data)
    }).catch(err =>{
        toastContainer("Error while updating","error")
    })
  }
  return (
    <Modal isOpen={open}>
      <ModalHeader         className="trivia_modal_header_bg" toggle={onClose}>Edit reward</ModalHeader>
      <ModalBody>
        <div className="my-3">
          <Label>Reward Name</Label>
          <Input
            className="w-100"
            value={rewardName}
            onChange={(e) => setRewardName(e.target.value)}
            placeholder="Enter reward name"
          />
        </div>

        <div className="my-3">
          <Label>Select Reward end date </Label>

          <DatePicker
            id="actionDueDate"
            placeholderText="Enter date: MM/DD/YYYY"
            className="form-control filter-action-date-input"
            selected={rewardDate ? moment(rewardDate).local():null}
            onChange={handleDateChange}
            showYearDropdown
          />
        </div>

        <div className="my-3">
        <div className="my-3">
              <Label>Select when to notify you</Label>
              <Select
                value={adminEmailTriggerType}
                options={REWARD_ADMIN_EMAIL_TYPES}
                onChange={(v) => {
                  setAdminEmailTriggerType(v.value)
                }}
                placeholder="Select notification trigger type ..."
              />
            </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="success" className="mr-4 btn-success" onClick={() => {handleUpdate()}}>
          Edit <BiEditAlt className="ml-2" />{" "}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
